var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "google_storage-b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "99.845%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4387FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4683EA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "google_storage-a",
    d: "M9.3378348,36.349488 L0.5176332,21.0724752 C-0.1725444,19.8770544 -0.1725444,18.404232 0.5176332,17.2088112 L9.3378348,1.931832 C10.0280124,0.7364112 11.3035356,0 12.6838908,0 L30.324294,0 C31.7046492,0 32.9801724,0.7364112 33.67035,1.931832 L42.4905516,17.2088112 C43.1807292,18.404232 43.1807292,19.8770544 42.4905516,21.0724752 L33.67035,36.3494544 C32.9801724,37.5448752 31.7046492,38.2812864 30.324294,38.2812864 L12.6838908,38.2812864 C11.3035356,38.2812864 10.028046,37.5449088 9.3378348,36.349488 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_storage-c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#google_storage-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#google_storage-b)",
    fillRule: "nonzero",
    xlinkHref: "#google_storage-a"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillRule: "nonzero",
    points: "39.963 25.861 28.724 14.622 16.569 15.739 14.214 18.087 16.216 20.089 14.234 23.609 29.231 38.607 32.865 38.608",
    mask: "url(#google_storage-c)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M14.3471664.0904176L.4246704.0908208C.2004912.0908208.017136.274176.017136.4983552L.0175392 3.376632C.0175392 3.6003408.2008944 3.7837632.4246704 3.7837632L14.3467968 3.7837632C14.5709424 3.7837632 14.7542976 3.6003744 14.7542976 3.376632L14.7542976.497952C14.7542976.274176 14.5712784.0904176 14.3471664.0904176M12.1913904 2.7700512C11.732112 2.7700512 11.359656 2.3957472 11.358816 1.936872 11.359656 1.4759472 11.7308688 1.1045328 12.1913904 1.1045328 12.6515088 1.1045328 13.024368 1.4751744 13.024368 1.936872 13.024368 2.3965872 12.6515088 2.7700512 12.1913904 2.7700512M14.3471664 5.6233296L.4246704 5.6237328C.2004912 5.6237328.017136 5.8072896.017136 6.0318384L.0175392 8.909544C.0175392 9.1332528.2008944 9.3170784.4246704 9.3170784L14.3467968 9.3170784C14.5709424 9.3170784 14.7542976 9.1332528 14.7542976 8.909544L14.7542976 6.0312C14.7542976 5.8073232 14.5712784 5.6233296 14.3471664 5.6233296M12.1913904 8.3029968C11.732112 8.3029968 11.359656 7.9288944 11.358816 7.4698176 11.359656 7.0089264 11.7308688 6.63768 12.1913904 6.63768 12.6515088 6.63768 13.024368 7.0086912 13.024368 7.4698176 13.024368 7.9300704 12.6515088 8.3029968 12.1913904 8.3029968",
    transform: "translate(14.112 14.437)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStorage);
export default __webpack_public_path__ + "static/media/Google_Storage.116098a5.svg";
export { ForwardRef as ReactComponent };